import { actions } from '@/store/module/member/action/actions.js';
import { mutations } from '@/store/module/member/mutation/mutations.js';

export const member = {
	namespaced: true,

	state () {
		return {
			invitations: []
		};
	},

	actions,
	mutations
};
